
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA au Tampon dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads au Tampon certifiée Google Partner, accompagne les entreprises tamponnaises pour renforcer leur visibilité en ligne et conquérir de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads au Tampon dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads au Tampon certifiée Google Partner, accompagne les entreprises tamponnaises pour renforcer leur visibilité en ligne et conquérir de nouveaux clients.",
        },
      ],
    };
  },
};
